export interface SearchOption {
  label: string;
  value: string;
  icon: JSX.Element;
}

export enum SearchType {
  Regular = 'regular',
  AI = 'ai'
}
